import { getRoomPanelViewState } from './getRoomPanelViewState';

export default function isAnyFilterApplied(viewStateId: string | null) {
    const {
        roomFilterState: { selectedFilters, shouldGetSpaces },
        roomListPickerViewState: { selectedOption },
    } = getRoomPanelViewState(viewStateId);

    return !!selectedFilters?.length || !!selectedOption || !!shouldGetSpaces;
}
